import request from '@/libs/request'

//质量检测 列表
export function qualityInspectionsListApi (data) {
  return request({
    url: `quality/qualityInspections`,
    method: 'get',
    params: data
  })
}

//质量检测 详情
export function qualityInspectionsInfoApi (id) {
  return request({
    url: `quality/qualityInspections/` + id,
    method: 'get'
  })
}

//质量检测 编辑/添加
export function qualityInspectionsSaveApi (data) {
  return request({
    url: `quality/qualityInspections`,
    method: 'post',
    data: data
  })
}

//质量检测 删除
export function qualityInspectionsDelApi (id) {
  return request({
    url: `quality/qualityInspections/` + id,
    method: 'delete'
  })
}

